import { lazy } from "react";
import { ICON_TYPE } from "components/icons/icon";
import { DateRangeSupport } from "helpers/shared/formatters/dates";
import { HQ_FEATURE_FLAGS, LD_FEATURE_FLAGS } from "types/context";
import type { ISectionProps } from "types/navigation";

export const CAPITAL_MERCHANT_PORTAL_PATH = "/capital/advances";

export const CAPITAL_ONBOARDING_PATH = "/capital";

export const CAPITAL: ISectionProps = {
  feature: "Lightspeed Capital",
  icon: ICON_TYPE.CAPITAL,
  component: lazy(() =>
    import("containers/lspay/capital_containers").then((module) => ({
      default: module.CapitalOnboardingPortalContainer,
    }))
  ),
  path: "/capital",
  subSections: [
    {
      feature: "Advances",
      level: ["store"],
      scope: ["staff", "superuser"],
      path: CAPITAL_MERCHANT_PORTAL_PATH,
      dateSupport: DateRangeSupport.NONE,
      requiresFeatureFlag: LD_FEATURE_FLAGS.lspdCapitalMerchantPortal,
      component: lazy(() =>
        import("containers/lspay/financial_services_containers").then(
          (module) => ({
            default: module.MerchantPortalContainer,
          })
        )
      ),
    },
  ],
  requiresFeatureFlagHandler: (featureFlags) =>
    !featureFlags[HQ_FEATURE_FLAGS.adyenMerchantPortal] &&
    (featureFlags[LD_FEATURE_FLAGS.lspdCapitalOffer] ||
      featureFlags[LD_FEATURE_FLAGS.lspdCapitalMerchantPortal]),
  dateSupport: DateRangeSupport.NONE,
  level: ["store"],
  secondaryNavigationDisabled: true,
  pathHandler: ({ featureFlags }) =>
    featureFlags.lspdCapitalMerchantPortal
      ? CAPITAL_MERCHANT_PORTAL_PATH
      : "/capital",
};
